import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from '../axios.jsx';
import { Modal, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';

const URI_CIT = 'activarEri/';
const URI_REU = 'resultadoeri/';

// Ajusta esto si tu axios.jsx no expone baseURL directamente
const FILES_BASE_URL = (axios.defaults && axios.defaults.baseURL) || '';

const ViewERI = () => {
  const { codigo } = useParams();
  const navigate = useNavigate();

  const [citas, setCitas] = useState([]);
  const [reuniones, setReuniones] = useState([]);
  const [loading, setLoading] = useState(false);

  const [viewItem, setViewItem] = useState(null);
  const [showViewCitas, setShowViewCitas] = useState(false);
  const [showViewReuniones, setShowViewReuniones] = useState(false);
  const [showEditCitas, setShowEditCitas] = useState(false);
  const [showEditReunion, setShowEditReunion] = useState(false);


  const [showModalCita, setShowModalCita] = useState(false);
  const [showModalReunion, setShowModalReunion] = useState(false);

  // Modal dedicado para subir/reemplazar el PDF del Sitrep
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadTarget, setUploadTarget] = useState(null); // registro sobre el que se sube el PDF
  const [uploadFile, setUploadFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [fechaCita, setFechaCita] = useState('');
  const [horaCita, setHoraCita] = useState('');
  const [tema, setTema] = useState('');
  const [conclusion, setConclusion] = useState('');

  const [gestor, setGestor] = useState('');
  const [usernivel, setUsernivel] = useState('');

  const resetCitaFields = () => {
    setFechaCita('');
    setHoraCita('');

    setTema('');
  };

  const resetReunionFields = () => {

    setConclusion('');
  };

  const resetUploadFields = () => {
    setUploadTarget(null);
    setUploadFile(null);
    setUploading(false);
  };

  const getLocalDateString = (inputDate) => {
    const date = new Date(inputDate + 'T00:00:00');
    const offset = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - offset);
    return date.toISOString().split('T')[0];
  };

  // ¿El usuario actual puede subir/reemplazar/eliminar el documento de este registro?
  // Reglas: si aún no hay documento, cualquier gestor puede cargarlo (se vuelve el dueño).
  // Si ya hay uno, solo el gestor que lo cargó (Gestor_Documento) o un admin (nivel 1) pueden tocarlo.
  const puedeGestionarDocumento = (registro) => {
    if (!registro) return false;
    if (usernivel === '1') return true;
    if (!registro.Documento_Sitrep) return true;
    return registro.Gestor_Documento === gestor;
  };

  useEffect(() => {
    const user = sessionStorage.getItem('username');
    const nivel = sessionStorage.getItem('usernivel');
    if (user) setGestor(user);
    if (nivel) setUsernivel(nivel);

    fetchData();
    }, [codigo]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [resC, resR] = await Promise.all([
        axios.get(`${URI_CIT}${codigo}`),
        axios.get(`${URI_REU}${codigo}`)
      ]);
      const norm = data => Array.isArray(data) ? data : data ? [data] : [];
      setCitas(norm(resC.data));
      setReuniones(norm(resR.data));
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: 'error', title: 'Error al cargar datos' });
      setCitas([]);
      setReuniones([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCita = async (blog) => {
    if (usernivel === '1') {
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: 'Esta acción eliminará la cita permanentemente.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  });
  

  if (result.isConfirmed) {
    try {
      await axios.delete(`${URI_CIT}${blog.id}`);
      await axios.delete(`${URI_REU}codigo/${blog.Codigo}`);
      await axios.put(`sat/codigo/${codigo}`, 
            {Activa_ERI:"NO",});
      Swal.fire('Eliminado', 'La cita fue eliminada correctamente.', 'success');
      fetchData(); // refresca la lista
    } catch (error) {
      Swal.fire('Error', 'No se pudo eliminar la cita.', 'error');
    }
    
  }
    }else {
          Swal.fire({
            icon: 'warning',
            title: 'Acción no permitida',
            text: 'Esta acción solo está permitida para administradores.',
          });}
  
  
};

const setEditReunionFields = (r) => {
   setConclusion(r.Sitrep);
};

const handleDeleteReunion = async (id) => {
  if (usernivel === '1') {
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esto eliminará la reunión de forma permanente.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${URI_REU}${id}`);
        Swal.fire('Eliminado', 'La reunión fue eliminada.', 'success');
        fetchData();
      } catch (error) {
        // Manejo de errores más específico
        if (error.response && error.response.status === 403) {
          Swal.fire('Error', 'No tienes permiso para eliminar esta reunión.', 'error');
        } else {
          Swal.fire('Error', 'No se pudo eliminar la reunión.', 'error');
        }
      }
    }
  } else {
    // Este else debe estar aquí, fuera del primer if
    Swal.fire({
      icon: 'warning',
      title: 'Acción no permitida',
      text: 'Esta acción solo está permitida para administradores.',
    });
  }
};

  // Abre el modal de subida para un registro específico de la tabla (con validación de permisos)
  const abrirSubirSitrep = (registro) => {
    if (!puedeGestionarDocumento(registro)) {
      Swal.fire({
        icon: 'warning',
        title: 'Acción no permitida',
        text: 'Solo el gestor que cargó este documento o un administrador pueden modificarlo.',
      });
      return;
    }
    setUploadTarget(registro);
    setUploadFile(null);
    setShowUploadModal(true);
  };

  // Sube (o reemplaza) el PDF del Sitrep del registro seleccionado
  const handleUploadSitrep = async () => {
    if (!uploadFile) {
      Swal.fire({ icon: 'warning', title: 'Selecciona un archivo PDF' });
      return;
    }
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('documentoSitrep', uploadFile);
      // Identifican quién hace la petición, para que el backend valide permisos
      formData.append('solicitante', gestor);
      formData.append('usernivel', usernivel);

      await axios.put(`${URI_REU}${uploadTarget.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      Swal.fire({
        icon: 'success',
        title: 'Sitrep cargado',
        text: 'El PDF se guardó correctamente.',
        timer: 1800,
        showConfirmButton: false,
      });

      setShowUploadModal(false);
      resetUploadFields();
      fetchData();
    } catch (error) {
      if (error.response && error.response.status === 403) {
        Swal.fire('Acción no permitida', error.response.data?.message || 'No tienes permiso para modificar este documento.', 'error');
      } else {
        Swal.fire('Error', 'No se pudo subir el Sitrep', 'error');
      }
    } finally {
      setUploading(false);
    }
  };

  // Elimina el documento Sitrep (registro + archivo físico), con confirmación y validación de permisos
  const handleDeleteSitrep = async (registro) => {
    if (!puedeGestionarDocumento(registro)) {
      Swal.fire({
        icon: 'warning',
        title: 'Acción no permitida',
        text: 'Solo el gestor que cargó este documento o un administrador pueden eliminarlo.',
      });
      return;
    }

    const result = await Swal.fire({
      title: '¿Eliminar documento Sitrep?',
      text: 'Se borrará el registro y el archivo PDF de forma permanente.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });
    if (!result.isConfirmed) return;

    try {
      await axios.delete(`${URI_REU}${registro.id}/documento`, {
        data: { solicitante: gestor, usernivel },
      });
      Swal.fire('Eliminado', 'El documento Sitrep fue eliminado.', 'success');
      fetchData();
    } catch (error) {
      if (error.response && error.response.status === 403) {
        Swal.fire('Acción no permitida', error.response.data?.message || 'No tienes permiso para eliminar este documento.', 'error');
      } else {
        Swal.fire('Error', 'No se pudo eliminar el documento Sitrep', 'error');
      }
    }
  };


  return (
    <div className="container mb-3 eri-container">
      {/* Estilos propios para tablas y modales, mismo lenguaje visual que ViewSARS */}
      <style>{`
        .eri-container h3 {
          font-weight: 700;
          color: #1f3a5f;
        }

        .eri-card {
          background: #fff;
          border-radius: 14px;
          box-shadow: 0 2px 14px rgba(0,0,0,0.08);
          padding: 1.25rem 1.25rem 0.5rem;
          margin-bottom: 1.75rem;
        }

        .eri-card-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }

        .eri-table-wrapper {
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #e7ebf0;
        }

        .eri-table {
          margin-bottom: 0;
        }

        .eri-table thead th {
          background: linear-gradient(135deg, #7a1f2b, #b3323f);
          color: #fff;
          border: none;
          font-size: 0.85rem;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          padding: 0.85rem 0.9rem;
          vertical-align: middle;
        }

        .eri-table tbody td {
          padding: 0.75rem 0.9rem;
          vertical-align: middle;
          font-size: 0.92rem;
          border-color: #eef1f4;
        }

        .eri-table tbody tr:hover {
          background-color: #fdf3f4;
          transition: background-color 0.15s ease-in-out;
        }

        .eri-empty-row td {
          text-align: center;
          padding: 1.25rem;
          color: #8a94a6;
          font-style: italic;
        }

        .eri-action-btn {
          border-radius: 8px !important;
          margin: 0 2px;
        }

        .eri-listado-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 10px;
          border-radius: 999px;
          font-size: 0.78rem;
          font-weight: 600;
        }

        .eri-listado-pill.pendiente {
          background: #fff4e5;
          color: #b15a00;
        }

        .eri-listado-pill.cargado {
          background: #e6f6ec;
          color: #1e7e42;
        }

        .eri-listado-owner {
          font-size: 0.74rem;
          color: #8a94a6;
        }

        /* Modales */
        .modal-header.eri-header-cita {
          background: #7a1f2b;
          color: #fff;
        }
        .modal-header.eri-header-reunion {
          background: #b3323f;
          color: #fff;
        }
        .modal-header.eri-header-upload {
          background: #1e7e42;
          color: #fff;
        }
        .modal-header.eri-header-cita .btn-close,
        .modal-header.eri-header-reunion .btn-close,
        .modal-header.eri-header-upload .btn-close {
          filter: invert(1) brightness(2);
        }

        .eri-modal-body .form-group {
          margin-bottom: 1rem;
        }

        .eri-modal-body label {
          font-weight: 600;
          color: #334155;
          font-size: 0.88rem;
          margin-bottom: 4px;
          display: block;
        }

        .eri-modal-body .form-control,
        .eri-modal-body textarea {
          border-radius: 8px;
          border: 1px solid #dbe2ea;
        }

        .eri-file-drop {
          border: 2px dashed #b9c6d6;
          border-radius: 10px;
          padding: 1.5rem;
          text-align: center;
          background: #f9fbfd;
        }

        .eri-file-drop p {
          margin-bottom: 0.5rem;
          color: #5b6b82;
          font-size: 0.9rem;
        }
      `}</style>

      <h3>Activación Equipo de Respuesta Inmediata (ERI) {codigo}</h3>

      {/* Tabla de Citas / Activación */}
      <div className="eri-card">
        <div className="eri-card-header">
          <h5 className="mb-0">Activación</h5>
          <Button
            variant="success"
            onClick={() => setShowModalCita(true)}
            disabled={citas.length > 0}
          >
            Activar ERI
          </Button>
        </div>

        {loading ? <p>Cargando citas...</p> : (
          <div className="eri-table-wrapper">
            <table className="table table-striped eri-table">
              <thead>
                <tr>
                  <th>Fecha Cita</th><th>Hora</th><th>Gestor</th><th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {citas.length ? citas.map(c => (
                  <tr key={c.id}>
                    <td>{c.Fecha}</td>
                    <td>{c.Hora}</td>
                    <td>{c.Gestor}</td>
                    <td>
                      <Button variant="info" size="sm" className="eri-action-btn" onClick={() => {
                        setViewItem(c);
                        setShowViewCitas(true);
                      }}>
                        <i className="fas fa-eye"></i>
                      </Button>
                      <Button
                        variant="warning"
                        size="sm"
                        className="eri-action-btn"
                        onClick={() => {
                          if (usernivel === '1') {
                            setViewItem(c);
                            setFechaCita(c.Fecha);
                            setHoraCita(c.Hora);
                            setTema(c.Accion);
                            setShowEditCitas(true);
                          } else {
                            Swal.fire({
                              icon: 'warning',
                              title: 'Acción no permitida',
                              text: 'Esta acción solo está permitida para administradores.',
                            });
                          }
                        }}
                      >
                        <i className="fas fa-edit"></i>
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        className="eri-action-btn"
                        onClick={() => handleDeleteCita(c)}
                      >
                        <i className="fas fa-trash"></i>
                      </Button>
                    </td>
                  </tr>
                )) : (
                  <tr className="eri-empty-row"><td colSpan="4">No se ha activado ningún ERI</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Tabla de Conclusiones */}
      <div className="eri-card">
        <div className="eri-card-header">
          <h5 className="mb-0">Conclusiones</h5>
          <Button variant="primary" onClick={() => {
            if (!citas || citas === 0 || (Array.isArray(citas) && citas.length === 0)) {
              Swal.fire({
                icon: 'warning',
                title: 'Activar Equipo de Respuesta Inmediata',
              });
              return;
            }
            setShowModalReunion(true);
          }}>
            Crear Reunión
          </Button>
        </div>

        {loading ? <p>Cargando Conclusiones...</p> : (
          <div className="eri-table-wrapper">
            <table className="table table-striped eri-table">
              <thead>
                <tr>
                  <th>Fecha Reunión</th>
                  <th>Hora</th>
                  <th>Gestor</th>
                  <th>Documento Sitrep</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {reuniones.length ? reuniones.map(r => {
                  const puedeGestionar = puedeGestionarDocumento(r);
                  return (
                    <tr key={r.id}>
                      <td>{r.Fecha}</td>
                      <td>{r.Hora}</td>
                      <td>{r.Gestor}</td>

                      {/* Columna Documento Sitrep: mismo patrón que Listado de Asistencia en SARS */}
                      <td>
                        {r.Documento_Sitrep ? (
                          <div>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                              <span className="eri-listado-pill cargado">
                                <i className="fas fa-check-circle"></i> Cargado
                              </span>
                              <a
                                href={`${FILES_BASE_URL}uploads/eri/${r.Documento_Sitrep}`}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-sm eri-action-btn"
                              >
                                <i className="fas fa-file-pdf"></i> Ver PDF
                              </a>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                className="eri-action-btn"
                                onClick={() => abrirSubirSitrep(r)}
                                disabled={!puedeGestionar}
                                title={puedeGestionar ? 'Reemplazar PDF' : 'Solo quien lo cargó o un administrador puede reemplazarlo'}
                              >
                                <i className="fas fa-sync-alt"></i> Reemplazar
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                className="eri-action-btn"
                                onClick={() => handleDeleteSitrep(r)}
                                disabled={!puedeGestionar}
                                title={puedeGestionar ? 'Eliminar PDF' : 'Solo quien lo cargó o un administrador puede eliminarlo'}
                              >
                                <i className="fas fa-trash"></i>
                              </Button>
                            </div>
                            {r.Gestor_Documento && (
                              <div className="eri-listado-owner mt-1">
                                Cargado por: <b>{r.Gestor_Documento}</b>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            <span className="eri-listado-pill pendiente">
                              <i className="fas fa-exclamation-circle"></i> Pendiente
                            </span>
                            <Button
                              variant="warning"
                              size="sm"
                              className="eri-action-btn"
                              onClick={() => abrirSubirSitrep(r)}
                            >
                              <i className="fas fa-upload"></i> Subir PDF
                            </Button>
                          </div>
                        )}
                      </td>

                      <td>
                        <Button variant="info" size="sm" className="eri-action-btn" onClick={() => {
                          setViewItem(r);
                          setShowViewReuniones(true);
                        }}>
                          <i className="fas fa-eye"></i>
                        </Button>
                        <Button
                          variant="warning"
                          size="sm"
                          className="eri-action-btn"
                          onClick={() => {
                            if (usernivel === '1') {
                              setViewItem(r);
                              setEditReunionFields(r);
                              setShowEditReunion(true);
                            } else {
                              Swal.fire({
                                icon: 'warning',
                                title: 'Acción no permitida',
                                text: 'Esta acción solo está permitida para administradores.',
                              });
                            }
                          }}
                        >
                          <i className="fas fa-edit"></i>
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          className="eri-action-btn"
                          onClick={() => handleDeleteReunion(r.id)}
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                }) : (
                  <tr className="eri-empty-row"><td colSpan="5">No hay reuniones registradas</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal Detalle Cita */}
      <Modal show={showViewCitas} onHide={() => {
        setShowViewCitas(false);
        setViewItem(null);
      }}>
        <Modal.Header closeButton className="eri-header-cita"><Modal.Title>Detalle de plan de accion ERI</Modal.Title></Modal.Header>
        <Modal.Body className="eri-modal-body">
          {viewItem && (
            <>
              <p><strong>Código SAT:</strong> {viewItem.Codigo}</p>
              <p><strong>Fecha:</strong> {viewItem.Fecha}</p>
              <p><strong>Hora:</strong> {viewItem.Hora}</p>
              <p style={{ whiteSpace: 'pre-line' }}>
              <strong>Accion:</strong> {viewItem.Accion}</p>
              <p><strong>Gestor:</strong> {viewItem.Gestor}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={() => setShowViewCitas(false)}>Cerrar</Button></Modal.Footer>
      </Modal>

      {/* Modal Detalle Reunión */}
      <Modal show={showViewReuniones} onHide={() => {
        setShowViewReuniones(false);
        setViewItem(null);
      }}>
        <Modal.Header closeButton className="eri-header-reunion"><Modal.Title>Detalle de Conclusiones</Modal.Title></Modal.Header>
        <Modal.Body className="eri-modal-body">
          {viewItem && (
            <>
              <p><strong>Código SAT:</strong> {viewItem.Codigo}</p>
              <p><strong>Fecha:</strong> {viewItem.Fecha}</p>
              <p><strong>Hora:</strong> {viewItem.Hora}</p>
              <p>
                <strong>Documento Sitrep:</strong>{' '}
                {viewItem.Documento_Sitrep ? (
                  <a
                    href={`${FILES_BASE_URL}uploads/eri/${viewItem.Documento_Sitrep}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ver PDF
                  </a>
                ) : 'No adjunto'}
              </p>
              {viewItem.Gestor_Documento && (
                <p><strong>Cargado por:</strong> {viewItem.Gestor_Documento}</p>
              )}
              <p style={{ whiteSpace: 'pre-line' }}>
              <strong>Sitrep:</strong> {viewItem.Sitrep}</p>
              <p><strong>Gestor:</strong> {viewItem.Gestor}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={() => setShowViewReuniones(false)}>Cerrar</Button></Modal.Footer>
      </Modal>

      

      {/* Modal Activar Cita */}
       <Modal show={showModalCita} onHide={() => {
        setShowModalCita(false);
        resetCitaFields();
      }}>
        <Modal.Header closeButton className="eri-header-cita"><Modal.Title>Activar Equipo de Respuesta Inmediata</Modal.Title></Modal.Header>
        <Modal.Body className="eri-modal-body">
          <div className="form-group">
            <label>Fecha:</label>
            <input type="date" className="form-control" value={fechaCita} onChange={e => setFechaCita(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Hora:</label>
            <input type="time" className="form-control" value={horaCita} onChange={e => setHoraCita(e.target.value)} />
          </div>
           <div className="form-group">
            <label>Tema a tratar:</label>
            <textarea className="form-control" value={tema} onChange={e => setTema(e.target.value)}></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowModalCita(false);
            resetCitaFields();
          }}>Cancelar</Button>
          <Button variant="success" onClick={async () => {

            if (!fechaCita || !horaCita || !tema) {
                alert("Todos los campos son requeridos");
                return;
                }
                Swal.fire({
                    title: 'Guardando información...',
                    text: 'Por favor espera un momento',
                    allowOutsideClick: false,
                    didOpen: () => {
                      Swal.showLoading();
                    },
                  });
                

            try {
              await axios.post(URI_CIT, {
                Codigo: codigo,
                Fecha: fechaCita,
                Hora: horaCita,
                Accion: tema,
                Gestor: gestor,
              });
              axios.put(`sat/codigo/${codigo}`,
              {Activa_ERI:"SI",});
              Swal.fire({
                    icon: 'success',
                    title: 'Guardado exitoso',
                    text: 'La información se ha guardado correctamente.',
                    timer: 2000,
                    showConfirmButton: false,
                  });
              setShowModalCita(false);
              resetCitaFields();
              fetchData();
            } catch (error) {
              Swal.fire('Error', 'No se pudo activar el ERI', 'error');
            }
          }}>Guardar</Button>
        </Modal.Footer>
      </Modal>

      <Modal
  show={showEditCitas}
  onHide={() => {
    setShowEditCitas(false);
    resetCitaFields();
  }}
>
  <Modal.Header closeButton className="eri-header-cita">
    <Modal.Title>Editar activacion Equipo de Respuesta Inmediata</Modal.Title>
  </Modal.Header>

  <Modal.Body className="eri-modal-body">
    <div className="form-group">
      <label>Fecha:</label>
      <input
        type="date"
        className="form-control"
        value={fechaCita}
        onChange={e => setFechaCita(e.target.value)}
      />
    </div>
    <div className="form-group">
      <label>Hora:</label>
      <input
        type="time"
        className="form-control"
        value={horaCita}
        onChange={e => setHoraCita(e.target.value)}
      />
    </div>
    <div className="form-group">
      <label>Acciones:</label>
      <textarea
        className="form-control"
        value={tema}
        onChange={e => setTema(e.target.value)}
      ></textarea>
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => {
        setShowEditCitas(false);
        resetCitaFields();
      }}
    >
      Cancelar
    </Button>
    <Button
      variant="success"
      onClick={async () => {
        try {
          await axios.put(`${URI_CIT}${viewItem.id}`, {
            Codigo: codigo,
            Fecha: fechaCita,
            Hora: horaCita,
            Accion: tema,
            Gestor: gestor,
          });
          Swal.fire('Éxito', 'Cita actualizada correctamente', 'success');
          setShowEditCitas(false);
          resetCitaFields();
          fetchData();
        } catch (error) {
          Swal.fire('Error', 'No se pudo actualizar la cita', 'error');
        }
      }}
    >
      Guardar Cambios
    </Button>
  </Modal.Footer>
</Modal>


      {/* Modal Crear Reunión */}
      <Modal show={showModalReunion} onHide={() => {
        setShowModalReunion(false);
        resetReunionFields();
      }}>
        <Modal.Header closeButton className="eri-header-reunion"><Modal.Title>Crear Conclusiones</Modal.Title></Modal.Header>
        <Modal.Body className="eri-modal-body">
          <div className="form-group">
            <label>Conclusiones:</label>
            <textarea className="form-control" value={conclusion} onChange={e => setConclusion(e.target.value)}></textarea>
          </div>
          <p className="text-muted small mb-0">
            El documento Sitrep en PDF se sube después de guardar, desde el botón <b>"Subir PDF"</b> en la tabla de Conclusiones.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowModalReunion(false);
            resetReunionFields();
          }}>Cancelar</Button>
          <Button variant="primary" onClick={async () => {
            const now = new Date();
            const fecha = getLocalDateString(now.toISOString().slice(0, 10));
            const hora = now.toTimeString().slice(0, 5);
            try {
              if (!conclusion) {
                alert("Todos los campos son requeridos");
                return;
                }

              await axios.post(URI_REU, {
                Codigo: codigo,
                Fecha: fecha,
                Hora: hora,
                Sitrep: conclusion,
                Gestor: gestor
              });
              Swal.fire({
                icon: 'success',
                title: 'Conclusión registrada',
                text: 'Ahora puedes subir el documento Sitrep desde la tabla.',
              });
              setShowModalReunion(false);
              resetReunionFields();
              fetchData();
            } catch (error) {
              Swal.fire('Error', 'No se pudo registrar la conclusion', 'error');
            }
          }}>Guardar</Button>
        </Modal.Footer>
      </Modal>




  <Modal show={showEditReunion} onHide={() => {
  setShowEditReunion(false);
  resetReunionFields();
}}>
  <Modal.Header closeButton className="eri-header-reunion">
    <Modal.Title>Editar Conclusion</Modal.Title>
  </Modal.Header>
  <Modal.Body className="eri-modal-body">
     <div className="form-group">
      <label>Conclusiones:</label>
      <textarea
        className="form-control"
        value={conclusion}
        onChange={e => setConclusion(e.target.value)}
      ></textarea>
    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => {
        setShowEditReunion(false);
        resetReunionFields();
      }}
    >
      Cancelar
    </Button>
    <Button
      variant="primary"
      onClick={async () => {
        try {
          await axios.put(`${URI_REU}${viewItem.id}`, {
            Codigo: codigo,
            Sitrep: conclusion,
            Gestor: gestor,
          });
          Swal.fire('Actualizado', 'Conclusion actualizada correctamente', 'success');
          setShowEditReunion(false);
          resetReunionFields();
          fetchData();
        } catch (error) {
          Swal.fire('Error', 'No se pudo actualizar la Conclusion', 'error');
        }
      }}
    >
      Guardar Cambios
    </Button>
  </Modal.Footer>
</Modal>

      {/* Modal dedicado para subir/reemplazar el documento Sitrep */}
      <Modal show={showUploadModal} onHide={() => {
        setShowUploadModal(false);
        resetUploadFields();
      }}>
        <Modal.Header closeButton className="eri-header-upload">
          <Modal.Title>Documento Sitrep</Modal.Title>
        </Modal.Header>
        <Modal.Body className="eri-modal-body">
          {uploadTarget && (
            <p className="text-muted mb-3">
              Conclusión del <b>{uploadTarget.Fecha}</b> a las <b>{uploadTarget.Hora}</b>
            </p>
          )}
          <div className="eri-file-drop">
            <i className="fas fa-file-pdf fa-2x mb-2" style={{ color: '#1e7e42' }}></i>
            <p>Selecciona el PDF con el documento Sitrep</p>
            <input
              type="file"
              accept="application/pdf"
              className="form-control"
              onChange={(e) => setUploadFile(e.target.files[0] || null)}
            />
            {uploadFile && (
              <p className="mt-2 mb-0 text-success">
                <i className="fas fa-check-circle"></i> {uploadFile.name}
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowUploadModal(false);
            resetUploadFields();
          }}>Cancelar</Button>
          <Button variant="success" disabled={uploading} onClick={handleUploadSitrep}>
            {uploading ? 'Subiendo...' : 'Subir Sitrep'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Button variant="secondary" onClick={() => navigate(-1)}>Volver</Button>
    </div>
  );
};

export default ViewERI;